module.exports = __webpack_public_path__ + "static/media/Portrait-10068.bbd2f9c3.jpg";